import type { Weight } from "../stores/BaseTypes";
import type { Price } from "./Prices";
import { CustomerCartItem } from "./CustomerCartTypes";
import { AnonCartItem } from "./AnonCartTypes";
export type ArticleData = {
	bundleId: string;
	description: string;
	displayId?: string;
	subsys?: string | null;
	availability: ArticleAvailability;
	availableStock?: number | null;
	stockMustBeChecked?: boolean | null;
	minOrderQuantity?: number | null;
	maxOrderQuantity?: number | null;
	useMinQuantityMultiplier?: boolean | null;
	imageSources: ImageSources;
	categories: string[];
	bundleSize?: string | null;
	packaging?: PackagingInfo;
	chargedByWeight: boolean;
	weightPerPiece?: Weight | null;
	serviceOptions?: ServiceOption[];
	selectedFulfillmentType?: FulfillmentType | null;
	selectedDeliveryMode?: string | null;
	selectedDeliveryModeInfo?: SpecificDeliveryInfo | null;
	customerBuyable?: boolean | null;
	employeeBuyable?: boolean | null;
	dataAgeMs?: number;
	outdated: boolean;
	missingReasons?: string[];
	ownBrand?: string | null;
	expectedDeliveryDate?: string | null;
	trackingId?: string | null;
	licenseType?: string | null;
};
export type PackagingInfo = {
	size: string | null | undefined;
	typeId: string | null | undefined;
	description: string | null | undefined;
};
export type SpecificDeliveryInfo = {
	leadDaysWithQuantities?: LeadDaysWithQuantity[] | null;
	fulfillingStoreId: string | null | undefined;
};
export type LeadDaysWithQuantity = {
	quantity: number | null | undefined;
	days: number | null | undefined;
	deliveryDate: string | null | undefined;
};
export type FulfillmentType = "FSD" | "WEBSHOP" | "DROP_SHIPMENT" | "CLICK_AND_COLLECT";
export type ArticleAvailability = "UNKNOWN" | "AVAILABLE" | "LIMITED" | "UNAVAILABLE";
export type ImageSources = {
	imageUrl1?: string;
	imageUrl2?: string;
	imageUrl3?: string;
	imageUrlL?: string;
	imageUrlS?: string;
};
export type ServiceOption = {
	readonly id: string;
	readonly mandatory: boolean;
	readonly appliesTo: "BUNDLE" | "BASKET";
	readonly description: string;
	readonly priceId: string | null | undefined;
	readonly name: string;
	readonly serviceFee: Price;
	readonly employeeOnly: boolean;
	readonly types?: Array<string>;
	selected: boolean;
};
export const createDummyArticle = (bundleId: string): ArticleData => ({
	bundleId,
	description: bundleId,
	availability: "UNKNOWN",
	availableStock: 999,
	stockMustBeChecked: false,
	imageSources: Object.freeze({}),
	categories: [],
	chargedByWeight: false,
	serviceOptions: [],
	customerBuyable: false,
	employeeBuyable: false,
	outdated: true,
	missingReasons: ["PENDING"],
});

export const extractArticleData = (item: AnonCartItem | CustomerCartItem | null | undefined): ArticleData | null => {
	if (!item || !(item instanceof Object)) {
		return null;
	}

	const {
		bundleId,
		description,
		displayId,
		availability,
		availableStock,
		stockMustBeChecked,
		minOrderQuantity,
		maxOrderQuantity,
		imageSources,
		categories,
		bundleSize,
		chargedByWeight,
		weightPerPiece,
		serviceOptions,
		selectedFulfillmentType,
		customerBuyable,
		employeeBuyable,
		dataAgeMs,
		outdated,
		missingReasons,
		trackingId,
		ownBrand,
		licenseType,
	} = item;

	if (
		!bundleId ||
		!description ||
		!availability ||
		!imageSources ||
		!categories ||
		!serviceOptions ||
		(missingReasons || []).includes("PENDING")
	) {
		return null;
	}

	return {
		bundleId,
		description,
		displayId,
		availability,
		availableStock,
		stockMustBeChecked,
		minOrderQuantity,
		maxOrderQuantity,
		imageSources,
		categories,
		bundleSize,
		chargedByWeight,
		weightPerPiece,
		serviceOptions,
		customerBuyable,
		employeeBuyable,
		selectedFulfillmentType,
		dataAgeMs,
		outdated,
		missingReasons,
		trackingId,
		ownBrand,
		licenseType,
	};
};
